import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { needsEmailVerification } from '../utils/authVerification';

/**
 * Requires auth token; only accessible while email verification is pending.
 * Verified users are sent to the dashboard.
 */
export default function VerificationRoute({ children }) {
  const location = useLocation();
  const { user, token, verificationRequired, mustChangePassword } = useSelector((state) => state.auth);

  const storedToken = localStorage.getItem('auth_token');

  if (!storedToken && !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const mustSetupPassword =
    mustChangePassword || localStorage.getItem('auth_must_change_password') === 'true';
  if (mustSetupPassword) {
    return <Navigate to="/auth/complete-invited-password-setup" replace />;
  }

  const pending =
    verificationRequired ||
    localStorage.getItem('auth_verification_required') === 'true' ||
    (user ? needsEmailVerification(user) : Boolean(storedToken));

  if (!pending && user && !needsEmailVerification(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
